/**
 * @generated SignedSource<<2e2961d4401627e64f71f8b88304ffde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsMapContributionTooltipContent_contribution",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReactableMeasures_reactable"
    }
  ],
  "type": "Contribution",
  "abstractKey": null
};

node.hash = "cbee3d07b223ccf154c6f8d715897c78";

module.exports = node;
